import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, PencilRuler, Network } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import ManualFlowEditor from '../components/ManualFlowEditor';
import FlowTreeView from '../components/FlowTreeView';

const OwnershipFlowPage = () => {
  const { caseId } = useParams();
  const [tab, setTab] = useState('tree');
  const [treeKey, setTreeKey] = useState(0);

  const onTabChange = (v) => {
    // Remount Tree View each time it becomes active so edits saved in the
    // Builder are always reflected (avoids a stale read-only tree).
    if (v === 'tree') setTreeKey((k) => k + 1);
    setTab(v);
  };

  return (
    <div className="space-y-4" data-testid="ownership-flow-page">
      <div className="flex items-center gap-4">
        <Link to={`/cases/${caseId}`}>
          <Button variant="ghost" size="icon">
            <ArrowLeft size={20} />
          </Button>
        </Link>
        <div>
          <h1 className="text-2xl font-bold text-[#1e3a5f]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Ownership Flow
          </h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Advocate-controlled legal title chain · Tree View shows the connected flow · Builder edits it · Independent of the DDR report
          </p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={onTabChange}>
        <TabsList data-testid="flow-tabs">
          <TabsTrigger value="tree" data-testid="tree-view-tab">
            <Network size={15} className="mr-1.5" /> Tree View
          </TabsTrigger>
          <TabsTrigger value="builder" data-testid="builder-tab">
            <PencilRuler size={15} className="mr-1.5" /> Builder
          </TabsTrigger>
        </TabsList>

        <TabsContent value="tree" className="mt-4">
          <FlowTreeView key={treeKey} caseId={caseId} />
        </TabsContent>
        <TabsContent value="builder" className="mt-4">
          <ManualFlowEditor caseId={caseId} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default OwnershipFlowPage;
